import { createSelector } from 'reselect';

import { getWorkOrderManagement } from './getWorkOrderManagement';

const getWorkOrderOperationLaborTickets = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement?.workOrderOperationLaborTickets;
  }
);

export { getWorkOrderOperationLaborTickets };
